import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './auth/AuthContext';
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import { MantineProvider, createTheme } from '@mantine/core';
import { Notifications } from '@mantine/notifications';

const theme = createTheme({
  primaryColor: 'pink',
  colors: {
    pink: [
      '#fff1f2',
      '#ffe4e6',
      '#fecdd3',
      '#fda4af',
      '#fb7185',
      '#f472b6',
      '#ec4899',
      '#db2777',
      '#be185d',
      '#9f1239',
    ],
  },
  fontFamily:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, "Apple Color Emoji", "Segoe UI Emoji"',
  defaultRadius: 'md',
  components: {
    Button: {
      defaultProps: {
        color: 'pink',
        size: 'md', // Ensure consistent button sizes
      },
      styles: {
        root: {
          // Ensure minimum touch target size on mobile
          '@media (max-width: 768px)': {
            minHeight: '44px',
            fontSize: '16px', // Prevent zoom on iOS
          },
        },
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MantineProvider theme={theme} defaultColorScheme="light">
      <Notifications position={{ base: 'top-center', sm: 'top-right' }} />
      <AuthProvider>
        <App />
      </AuthProvider>
    </MantineProvider>
  </React.StrictMode>
);

